<template>
    <TagsBadges v-if="!isEmpty" :tags="tags" />
</template>

<script>
import TagsBadges from '@/js/components/common/badges/TagsBadges';

export default {
    name: 'ExhibitionTags',

    components: {TagsBadges},

    props: {
        related: {type: Object, required: true},
    },

    computed: {
        isEmpty() {
            return this.tags.length === 0;
        },

        tags() {
            if (!Array.isArray(this.related.tags)) {
                return [];
            }

            return this.related.tags.filter((tag) => !tag.is_configuration);
        },
    },
};
</script>
